import { render, staticRenderFns } from "./HeaderSystemMessages.vue?vue&type=template&id=3c9e5390&scoped=true&"
import script from "./HeaderSystemMessages.vue?vue&type=script&lang=js&"
export * from "./HeaderSystemMessages.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSystemMessages.vue?vue&type=style&index=0&id=3c9e5390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9e5390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c9e5390')) {
      api.createRecord('3c9e5390', component.options)
    } else {
      api.reload('3c9e5390', component.options)
    }
    module.hot.accept("./HeaderSystemMessages.vue?vue&type=template&id=3c9e5390&scoped=true&", function () {
      api.rerender('3c9e5390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/HeaderSystemMessages.vue"
export default component.exports